<template>
  <div>
    <user-list-add-new
      :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
      :role-options="roleOptions"
      @refetch-data="refetchData"
    />
    <user-edit
      :is-edit-user-sidebar-active.sync="isEditUserSidebarActive"
      :user-item.sync="userItem"
      @refetch-data="refetchData"
    />

    <!-- Filters -->
    <users-list-filters
      :role-filter.sync="roleFilter"
      :status-filter.sync="statusFilter"
      :role-options="roleOptions"
      :status-options="statusOptions"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <b-form>
              <label class="mr-1">Показать</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block"
              />
              <label class="ml-1">строка</label>
            </b-form>

          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Поиск..."
              />
              <b-button
                variant="primary"
                @click="isAddNewUserSidebarActive = true"
              >
                <span class="text-nowrap">Добавить</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchUsers"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Ничего не найдено"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: User -->
        <template #cell(user)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.name)"
                :variant="`light-${resolveUserRoleVariant(data.item.role)}`"
                :to="{ name: 'admin-users-view', params: { id: data.item.id } }"
              />
            </template>
            <b-link
              :to="{ name: 'admin-users-view', params: { id: data.item.id } }"
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.fullName }}
            </b-link>
            <small class="text-muted">@{{ data.item.username }}</small>
          </b-media>
        </template>

        <!-- Column: Role -->
        <template #cell(role)="data">
          <div class="text-nowrap">
            <feather-icon
              :icon="resolveUserRoleIcon(data.item.role)"
              size="18"
              class="mr-50"
              :class="`text-${resolveUserRoleVariant(data.item.role)}`"
            />
            <span class="align-text-top text-capitalize">{{ roleTranslate[data.item.role] }}</span>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            pill
            :variant="`light-${resolveUserStatusVariant(data.item.status)}`"
            class="text-capitalize"
            v-show="data.item.status == 2"
          >
            {{ statusTranslate[data.item.status] }}
          </b-badge>
          <b-form-checkbox
            v-show="data.item.status != 2"
            :checked="data.item.status ? true : false"
            class="custom-control-success"
            name="check-button"
            switch
            @change='changeStatus(data.item.status ? 0 : 1, data.item.id)'
          >
             <span class="switch-icon-left">
          <feather-icon icon="CheckIcon" />
        </span>
            <span class="switch-icon-right">
          <feather-icon icon="XIcon" />
        </span>
          </b-form-checkbox>

        </template>

        <!-- Column: StatusVerify -->
        <template #cell(status_verify)="data">
          <div>
            <b-card-text class="mb-0">
            </b-card-text>
            <b-form-checkbox
              v-show="data.item.role === 'dealer'"
              :checked="data.item.status_verify ? true : false"
              class="custom-control-success"
              name="check-button"
              switch
              @change='changeVerifyStatus(data.item.status_verify ? 0 : 1, data.item.id)'
            >
             <span class="switch-icon-left">
          <feather-icon icon="CheckIcon" />
        </span>
              <span class="switch-icon-right">
          <feather-icon icon="XIcon" />
        </span>
            </b-form-checkbox>
          </div>

        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item v-show="false" @click="editUser(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Изменить</span>
            </b-dropdown-item>

            <b-dropdown-item @click="deleteUser(data.item.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Удалить</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Показано {{ dataMeta.from }} до {{ dataMeta.to }} из {{ dataMeta.of }} строк</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BFormCheckbox, BForm, BCardText,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import useJwt from '@/auth/jwt/useJwt'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import UsersListFilters from './UsersListFilters.vue'
import useUsersList from './useUsersList'
import UserListAddNew from './UserListAddNew.vue'
import UserEdit from './UserEdit.vue'

export default {
  components: {
    UsersListFilters,
    UserListAddNew,
    UserEdit,
    BFormCheckbox,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BForm,
    BCardText,
    vSelect,
  },
  data() {
    return {
      userItem: {},
    }
  },
  methods: {
    deleteUser(id) {
      this.$http.post(`${this.url}/api/admin/user/${id}/delete`, {}, {}).then(() => {
        this.refetchData()
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Удалено',
            icon: 'TrashIcon',
            variant: 'success',
            text: 'Пользователь успешно удален.',
          },
        })
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Ошибка',
            icon: 'XIcon',
            variant: 'danger',
            text: 'Данные не удалены.',
          },
        })
      })
    },
    changeVerifyStatus(statusVerify, id) {
      this.overlayShow = true
      useJwt.dealerVerify({
        status: statusVerify,
        dealer_id: id,
      }).then(() => {
        this.refetchData()
      }).catch(error => {
        console.log(error.response.data)
      })
    },
    changeStatus(status, id) {
      this.overlayShow = true
      useJwt.userChangeStatus(id, {
        status,
      }).then(() => {
        this.refetchData()
      }).catch(error => {
        console.log(error.response.data)
      })
    },
    editUser(item) {
      this.userItem = item
      this.isEditUserSidebarActive = true
    },
  },
  created() {
    this.url = 'https://tojtel.tj'
  },
  setup() {
    const isAddNewUserSidebarActive = ref(false)
    const isEditUserSidebarActive = ref(false)

    const roleOptions = [
      { label: 'Администратор', value: 'admin' },
      { label: 'Пользователь', value: 'user' },
      { label: 'Дилер', value: 'dealer' },
    ]
    const roleTranslate = {
      admin: 'Администратор',
      user: 'Пользователь',
      dealer: 'Дилер',
    }

    const statusOptions = [
      { label: 'В ожидании', value: '2' },
      { label: 'Активен', value: '1' },
      { label: 'Не активен', value: '0' },
    ]

    const statusTranslate = {
      2: 'В ожидании',
      1: 'Активен',
      0: 'Не активен',
    }
    const statusVerifyTranslate = {
      1: 'Подтвержден',
      0: 'Не подтвержден',
    }

    const {
      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
      resolveUserStatusVerifyVariant,

      // Extra Filters
      roleFilter,
      statusFilter,
    } = useUsersList()

    return {
      dealerVerifyStatus: false,

      // Sidebar
      isAddNewUserSidebarActive,
      isEditUserSidebarActive,

      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
      resolveUserStatusVerifyVariant,

      roleOptions,
      statusOptions,
      roleTranslate,
      statusTranslate,
      statusVerifyTranslate,
      // Extra Filters
      roleFilter,
      statusFilter,
    }
  },
}
</script>

<style scoped>
.per-page-selector {
  width: 90px;
}

</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
